<script setup lang="ts">
// import TheWelcome from '../components/TheWelcome.vue'
import items from '@/stores/itemApp'
import AppNavbar from '@/components/AppNavbar.vue'

const itemList = items
</script>

<template>
  <AppNavbar>
    <v-row v-for="(category, index) in itemList" :key="index" class="my-4">
      <v-col cols="12">
        <h2 style="color: black">{{ category.category }}</h2>
      </v-col>
      <v-col v-for="(item, itemIndex) in category.items" :key="itemIndex" cols="12" md="2" sm="4">
        <v-tooltip>
          <template v-slot:activator="{ props }">
            <!-- Activator slot for tooltip -->
            <a
              v-bind="props"
              :href="item.url"
              class="link-domain"
              target="_blank"
              rel="noopener noreferrer"
            >
              <v-card class="mx-auto my-2" elevation="16" max-width="344">
                <v-card-item>
                  <v-card-title class="name">
                    <a :href="item.url" target="_blank" rel="noopener noreferrer">{{
                      item.name
                    }}</a>
                  </v-card-title>
                  <v-card-subtitle>
                    {{ item.url }}
                  </v-card-subtitle>
                </v-card-item>
              </v-card>
            </a>
          </template>
          <span>{{ item.name }}</span>
          <!-- Tooltip content -->
        </v-tooltip>
      </v-col>
    </v-row>
  </AppNavbar>
</template>

<style>
.name a {
  color: #3387cc;
  text-decoration: none;
}

.link-domain {
  text-decoration: none;
}
</style>
